import { render } from "./BlFormFieldRadio.vue?vue&type=template&id=3346b2b2&scoped=true"
import script from "./BlFormFieldRadio.vue?vue&type=script&lang=js"
export * from "./BlFormFieldRadio.vue?vue&type=script&lang=js"

import "./BlFormFieldRadio.vue?vue&type=style&index=0&id=3346b2b2&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3346b2b2"]])

export default __exports__